export default __webpack_public_path__ + "static/media/main_audio.89c54ff4.mp3";